module.exports = __webpack_public_path__ + "svg/spades.svg?35d2c70182163138c9bd69860ce36fa5";